export enum Role {
  User = 'User',
  None = 'None'
}
